// extracted by mini-css-extract-plugin
export var chatHtmlText = "_je-2";
export var chatLink = "_je-0";
export var chatText = "_je-1";